// The face on the cafe computer's screen: the friend Pino made there
// (sim world/Friend.js). Pixels on a 15 by 13 grid, drawn as square rects
// with crisp edges so it stays blocky at any size. Line eyes that blink,
// and a cat's markings around them: ears, a tabby stripe on the forehead,
// whiskers. Sam, 30 sep: pixelated and simple.
//
// `face` is the one word the sim sends (FriendScreen.faceOf): asleep,
// awake, curious, glad, low. No hooks, so the server-rendered /friend page
// and the cafe window both use it; the blink is CSS and stops for anybody
// who asked for less motion.

const EARS = [[1, 0], [1, 1], [2, 1], [1, 2], [2, 2], [3, 2], [13, 0], [12, 1], [13, 1], [11, 2], [12, 2], [13, 2]]
const STRIPES = [[7, 2], [7, 3], [7, 4], [5, 3], [5, 4], [9, 3], [9, 4]]
// two each side, a row apart, or they read as a moustache
const WHISKERS = [[0, 8], [1, 8], [2, 8], [0, 10], [1, 10], [2, 10], [12, 8], [13, 8], [14, 8], [12, 10], [13, 10], [14, 10]]
const NOSE = [[7, 9], [6, 10], [8, 10]]

const bar = (x, y0, y1) => Array.from({ length: y1 - y0 + 1 }, (_, i) => [x, y0 + i])
const EYES = {
  awake: [...bar(4, 6, 8), ...bar(10, 6, 8)],
  curious: [...bar(5, 5, 8), ...bar(11, 5, 8)],
  low: [...bar(4, 7, 8), ...bar(10, 7, 8)],
  glad: [[3, 7], [4, 6], [5, 7], [9, 7], [10, 6], [11, 7]],
  asleep: [[3, 7], [4, 7], [5, 7], [9, 7], [10, 7], [11, 7]],
}
const BLINKS = new Set(['awake', 'curious', 'low'])

function Px({ at, fill, opacity = 1 }) {
  return at.map(([x, y]) => <rect key={`${x}-${y}`} x={x} y={y} width="1.02" height="1.02" fill={fill} opacity={opacity} />)
}

export default function FriendFace({ face = 'awake', size = 48, color = 'currentColor', marks = null, title = null }) {
  const eyes = EYES[face] || EYES.awake
  const dim = face === 'asleep' ? 0.45 : face === 'low' ? 0.7 : 1
  const markColor = marks || color
  return (
    <svg
      viewBox="0 0 15 13"
      width={size}
      height={Math.round((size * 13) / 15)}
      shapeRendering="crispEdges"
      role="img"
      aria-label={title || `a face, ${face}`}
      style={{ display: 'block', opacity: dim, flexShrink: 0 }}
    >
      <style>{`
        .friendface-eyes { transform-box: fill-box; transform-origin: 50% 50%; animation: friendface-blink 5.3s steps(1, end) infinite; }
        @keyframes friendface-blink { 0%, 93% { transform: scaleY(1); } 94%, 96% { transform: scaleY(0.2); } 97%, 100% { transform: scaleY(1); } }
        @media (prefers-reduced-motion: reduce) { .friendface-eyes { animation: none; } }
      `}</style>
      <Px at={EARS} fill={markColor} opacity={0.75} />
      <Px at={STRIPES} fill={markColor} opacity={0.5} />
      <Px at={WHISKERS} fill={markColor} opacity={0.45} />
      <Px at={NOSE} fill={markColor} opacity={0.8} />
      <g className={BLINKS.has(face) ? 'friendface-eyes' : undefined}>
        <Px at={eyes} fill={color} />
      </g>
    </svg>
  )
}
